export default __webpack_public_path__ + "static/media/ai.4a95914d.svg";